/**
 * Web Service handler to retrieve and represent a list of appointment
 * transaction types
 *
 * @class AppointmentTransactionTypesWS
 */
function AppointmentTransactionTypesWS(parent) {
  var self = this;

  AbstractWS.apply(this, arguments);

  self.name = 'AppointmentTransactionTypesWS';
  self.queueId = ko.observable();
  self.transactionTypes = ko.observableArray([]);


	/**
	 * API Endpoint
	 *
	 * @method serviceURL
	 * @return none
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/kiosk/queues/' + self.queueId() + '/appointmentTransactionTypes';
  });


	/**
	 * Requests data from the API
	 *
	 * @method doRequest
	 * @return none
	 */
  self.doRequest = function () {
    qcal.setStatusMessage('Requesting FlexAppointment transaction types');

    AbstractWS.prototype.doRequest.apply(self, arguments);
  };


	/**
	 * Converts XML data returned from the API service into a collection
   * of structured objects
	 *
	 * @method processData
	 * @param {XMLDocument} xmlData
	 * @return none
	 */
  self.processData = function (xmlData) {
    var aTemp = [];
    var transTypes = [];

    qcal.setStatusMessage('FlexAppointment transaction types received', 1000);

    AbstractWS.prototype.processData.call(self, xmlData);

    self.transactionTypes.removeAll();

    transTypes = $(xmlData).find('transactionType').toArray() || [];

    aTemp = transTypes.reduce(function (arr, tt) {
      var tJSON = $.xml2json(tt);

      if (!tJSON.deleted) {
        arr.push({
          'id': parseInt(tJSON.id, 0),
          'name': tJSON.name,
          'description': tJSON.description
        });
      }


      return arr;
    }, []);

    self.transactionTypes(aTemp);
  };

};

AppointmentTransactionTypesWS.prototype = AbstractWS.prototype;
AppointmentTransactionTypesWS.prototype.constructor = AppointmentTransactionTypesWS;
